import React from 'react';
import { BehaviorEventRow } from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/event-row';
import { useBehaviorsList } from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/behaviors-list';
import type { RowProps } from '../catalog';
import styles from './index.module.styl';
import { RetentionCriteria } from './retention-criteria';
export function RetentionBehaviorDefinition(props: RowProps) {
  const {
    behaviors,
    handleUpdateBehavior,
    handleDuplicateBehavior
  } = useBehaviorsList(props.entry!, props.updateEntry);
  return <div className={styles.retentionBehavior} data-sentry-component="RetentionBehaviorDefinition" data-sentry-source-file="behavior-definition.tsx">
      {behaviors.map((subBehavior, index) => {
      return <BehaviorEventRow {...props} behavior={subBehavior} suffixLabel={index === 0 ? " then" : null} onDuplicate={() => handleDuplicateBehavior(index)} onSelect={behavior => handleUpdateBehavior(index, behavior)} />;
    })}
      <RetentionCriteria {...props} data-sentry-element="RetentionCriteria" data-sentry-source-file="behavior-definition.tsx" />

      {/* @todo(metrics) integrate this for retention frequency */}
      {/* <RetentionQuerySettingsReact
            retentionType={props.entry.behavior.retentionType}
            countingMethod={getCountingMethod()}
            onChange={handleSettingsChanged}
          /> */}
    </div>;
}